import * as t from "io-ts";
import { Company } from "./Company";
import { Credit } from "./Credit";
import { Introduction } from "./Introduction";
import { Job } from "./Job";
import { Monitor } from "./Monitor";
import { Onboarding } from "./Onboarding";
import { Payment } from "./Payment";

export const InfoEntity = t.type({
  company: t.array(Company),
  credit: t.array(Credit),
  job: t.array(Job),
  monitor: t.array(Monitor),
  onboarding: t.array(Onboarding),
  payment: t.array(Payment),
  introduction: t.array(Introduction),
});

export interface InfoEntity {
  company: Array<Company>;
  credit: Array<Credit>;
  job: Array<Job>;
  monitor: Array<Monitor>;
  onboarding: Array<Onboarding>;
  payment: Array<Payment>;
  introduction: Array<Introduction>;
}
